import * as Sentry from '@sentry/vue';
import router from '../../router';
import {
  TOKEN_VALIDATION,
  REFRESH_TOKEN,
  FETCH_DIGITAL_FORM,
  GET_DIGITAL_FORM_TOKEN
} from '../../store/types';
import store from '@/store';

// let errors_counter = {};

// Answers of the API when the ticket can no longer be edited by the
// collaborator (form steps and dependents step).
const PDF_FORM_UNAVAILABLE_MESSAGES = [
  'Este formulario ya no está disponible.',
  'El ticket no está editable en su estado actual.'
];
const PDF_FORM_STEP_ROUTES = [
  'insuredform1',
  'insuredform2',
  'insuredform3',
  'Auth',
  'Resume'
];
// Dependents form steps and the "not available" page of each variant.
const DEPENDENTS_FORM_ERROR_ROUTE_BY_STEP = {
  DependentsIncorporationFormStep1: 'DependentsIncorporationFormError',
  DependentsIncorporationFormStep2: 'DependentsIncorporationFormError',
  DependentsIncorporationNoDeliverableFormStep1:
    'DependentsIncorporationNoDeliverableFormError',
  DependentsIncorporationNoDeliverableFormStep2:
    'DependentsIncorporationNoDeliverableFormError'
};

const authorization = (http) => ({
  tokenResponse: async (error) => {
    if (error.message === 'canceled') return Promise.reject(error);
    const { response, config } = error;
    const { url } = config;

    switch (response?.status) {
      case 401: {
        if (url.includes('digital-form')) {
          const url_parts = url.split('/');

          // Si la url final es digital-form y esta invalida, significa que tengo que es el ultimo paso y debo mandar a ticket invalido
          if (url_parts[url_parts.length - 1] === 'digital-form') {
            router.push({ name: 'DigitalFormInvalidToken' });
          } else {
            // Si no lo es, aca tengo que hacer la logica para poder refrescar el token para poder hacer lo demas
            const resp = await store.dispatch(FETCH_DIGITAL_FORM);
            const { isTokenExpired } = resp.data;

            if (isTokenExpired === true) {
              const token = store.getters[GET_DIGITAL_FORM_TOKEN];
              router.push({
                name: 'DigitalFormExpiredToken',
                params: { token: token }
              });
            } else if (isTokenExpired === false) {
              router.push({ name: 'DigitalFormTokenStillWorking' });
            }
          }
        } else {
          // Validar de que los tokens estén bien
          const validation_resp = await store.dispatch(TOKEN_VALIDATION);
          // Como solo expiro el token, puedo volver a  refrescar el token
          if (validation_resp.resp === 'access expired') {
            await store.dispatch(REFRESH_TOKEN);
            return http(config);
          } else if (validation_resp.resp === 'no credentials') {
            router.push({ name: 'Login' });
          }
        }
        break;
      }
      // The dependents form answers 400 and the other forms 409.
      case 400:
      case 409: {
        // The ticket was closed while the collaborator was filling the form.
        const { name, params } = router.currentRoute.value;
        const isUnavailable = PDF_FORM_UNAVAILABLE_MESSAGES.includes(
          response.data?.message
        );
        if (isUnavailable && url.includes('digital-form')) {
          router.push({ name: 'DigitalFormUnavailable' });
        } else if (isUnavailable && PDF_FORM_STEP_ROUTES.includes(name)) {
          // The PDF form landing shows that it is no longer available.
          router.push({ name: 'insuredform', params: { token: params.token } });
        } else if (isUnavailable && DEPENDENTS_FORM_ERROR_ROUTE_BY_STEP[name]) {
          router.push({
            name: DEPENDENTS_FORM_ERROR_ROUTE_BY_STEP[name],
            params: { token: params.token }
          });
        }
        break;
      }
      default:
        break;
    }
    // Retornar esto si o si ya que lo necesita el interceptor
    Sentry?.captureException(error);
    return Promise.reject(error);
  }
});

export default authorization;
